'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var CircularProgress = require('../../Feedback/Progress/CircularProgress.js');
var Typography = require('../Typography/Typography.js');
var classNames = require('classnames');
var Grid = require('../../Layout/Grid/Grid.js');
var TableRow = require('./TableRow.js');
var TableCell = require('./TableCell.js');
require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var useStyles = makeStyles["default"](function (theme) {
  return {
    lightImage: {
      fill: theme.palette.secondary.light
    },
    lightText: {
      color: theme.palette.secondary.light
    },
    cell: {
      padding: '80px 0px'
    },
    displayBlock: {
      display: 'block',
      width: '100%'
    }
  };
});

var TableNoDataRow = function TableNoDataRow(_ref) {
  var loading = _ref.loading,
      image = _ref.image,
      colSpan = _ref.colSpan,
      description = _ref.description,
      component = _ref.component,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ["loading", "image", "colSpan", "description", "component", "className"]);

  var _useStyles = useStyles(),
      lightImage = _useStyles.lightImage,
      lightText = _useStyles.lightText,
      displayBlock = _useStyles.displayBlock,
      cell = _useStyles.cell;

  var renderImage = image ? React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].cloneElement(image, {
    className: classNames__default["default"](lightImage, className)
  })) : null;
  return React__default["default"].createElement(TableRow, _extends["default"]({
    component: component,
    className: classNames__default["default"](defineProperty({}, displayBlock, !!component))
  }, props), React__default["default"].createElement(TableCell, {
    component: component,
    className: classNames__default["default"](cell, defineProperty({}, displayBlock, !!component)),
    colSpan: !component ? colSpan : undefined,
    align: "center"
  }, loading ? React__default["default"].createElement(CircularProgress, null) : React__default["default"].createElement(Grid, {
    container: true,
    spacing: 24
  }, renderImage, description && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "h3",
    className: lightText
  }, description)))));
};

TableNoDataRow.defaultProps = {
  loading: false,
  image: null,
  description: null
};

module.exports = TableNoDataRow;
